[
  {
    "code": "FM-TRK",
    "name": "Chuuk"
  },
  {
    "code": "FM-KSA",
    "name": "Kosrae"
  },
  {
    "code": "FM-PNI",
    "name": "Pohnpei"
  },
  {
    "code": "FM-YAP",
    "name": "Yap"
  }
]